import { render, staticRenderFns } from "./FormResetPassword.vue?vue&type=template&id=4140a8c1"
import script from "./FormResetPassword.vue?vue&type=script&lang=js"
export * from "./FormResetPassword.vue?vue&type=script&lang=js"
import style0 from "./FormResetPassword.vue?vue&type=style&index=0&id=4140a8c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports